<template lang="pug">
.sticker
  //- .sticker-head
    .sticker-head-back(:style="`height: ${sysInfo.titleBarHeight + sysInfo.statusBarHeight * 2}px;`", @click="onBack")
  .sticker-body
    .sticker-title 贴纸库
    .sticker-box(v-for="(item, i) in list" :key="i")
      dl.sticker-box-date
        dt {{item.month}}月
        dd {{item.date}}
      .sticker-box-line
      .sticker-box-list
        .sticker-box-item(v-for="(task, j) in taskMap" :key="j", :class="'sticker-box-item-' + task.position")
          TaskImage(:flag="getTaskImage(task, j, item.list)")
    .tip 仅展示2025年11月11日后的足迹贴纸      
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import TaskImage from '@/components/footprint/TaskImage'
export default {
  name: 'Sticker',
  components: { TaskImage },
  props: {},
  data() {
    return {
      taskMap: {
        default_1: { position: '1', image: '1', imageGray: '1-g' },
        default_2: { position: '2', image: '2-l', imageGray: '2-g' },
        extend_3: { position: '3', image: '3', imageGray: '3-g' },
        master_11: { position: '4', image: '4-l', imageGray: '4-g' },
        master_10: { position: '5', image: '5', imageGray: '5-g' },
        master_5: { position: '6', image: '6', imageGray: '6-g' },
        master_3: { position: '7', image: '7-l', imageGray: '7-g' },
        branch_4: { position: '8', image: '8', imageGray: '8-g' },
        branch_6: { position: '9', image: '9', imageGray: '9-g' },
        branch_2: { position: '10', image: '10-l', imageGray: '10-g' },
        branch_3: { position: '11', image: '11-l', imageGray: '11-g' },
        branch_7: { position: '12', image: '12', imageGray: '12-g' },
      },
      branchTask: [],
      masterTask: [],
      defaultTask: ['default_1', 'default_2'],
    }
  },
  watch: {},
  computed: {
    ...mapState('app', ['sysInfo', 'router', 'user']),
    list() {
      const taskListAll = [
        ...this.branchTask.map((item) =>
          Object.assign({}, item, { key: `branch_${item.id}` })
        ),
        ...this.masterTask.map((item) =>
          Object.assign({}, item, { key: `master_${item.id}` })
        ),
      ]
        .map((item) =>
          Object.assign({}, item, { time: new Date(item.createdTime) })
        )
        .sort((prev, next) => next.time - prev.time)
        .reduce((prev, next, index, arr) => {
          const hit = prev.find(
            (prevItem) => prevItem.createdTime === next.createdTime
          )
          if (hit) {
            return prev
          } else {
            const list = [
              ...this.defaultTask,
              ...arr.filter((_, i) => i >= index).map(({ key }) => key),
            ]
            if (
              list.filter((item) => item.indexOf('master') === 0).length >= 3
            ) {
              // 集齐主线展点三张贴纸出现盲盒贴纸
              list.push('extend_3')
            }
            const [year, month, date] = next.createdTime.split('-')
            return [
              ...prev,
              {
                createdTime: next.createdTime,
                month: parseInt(month),
                date: parseInt(date),
                list: list,
              },
            ]
          }
        }, [])

      if (!taskListAll.length) {
        const today = new Date()
        today.getMonth + 1
        today.getDate
        return [
          {
            month: today.getMonth() + 1,
            date: today.getDate(),
            list: [...this.defaultTask],
          },
        ]
      } else {
        return taskListAll
      }
    },
  },
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app', ['GetFootprintTaskListAll']),
    onBack() {
      console.log(this.router.back)
      this.$router.replace(this.router.back)
    },
    getTaskImage(task, key, list) {
      return list.includes(key) ? task.image : task.imageGray
    },
    fetchFootprintTaskListAll() {
      this.setPending(true)
      this.GetFootprintTaskListAll({ userId: this.user.id })
        .then((data) => {
          this.branchTask = data.branchTask
          this.masterTask = data.masterTask
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
  },
  created() {
    this.fetchFootprintTaskListAll()
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.sticker
  background: #FFFFFF
.sticker-head
  height: pxRes(122); position: relative
  &-back
    box-sizing: content-box; padding: 0 pxRes(16.54); width: pxRes(21)
    position: absolute; top: 0; left: 0
    background: url("~assets/back-btn.png") center no-repeat
    background-size: pxRes(11)
.sticker-body
  color: #333333;
  .sticker-title
    +text(30, 42); padding: 0 0 0 pxRes(25);
  .sticker-box
    margin: pxRes(50) 0; position: relative
    dl.sticker-box-date
      width: pxRes(76); position: absolute; left: 0; top: 0; text-align: center; margin: 0
      dt
        +text(13, 19); color: #999999; font-weight: 600;
      dd
        +text(33, 33); margin: 0;font-weight: bold;
    .sticker-box-line
      width: pxRes(76); position: absolute; left: 0; top: pxRes(62); bottom: pxRes(10); text-align: center; margin: 0
      background: url("~assets/footprint/img-dot.png") center top repeat-y
      background-size: pxRes(3.5)
    .sticker-box-list
      margin: 0 0 0 pxRes(80); padding: 0 0 pxRes(28); position: relative; height: pxRes(568)
    .sticker-box-item
      position: absolute
      img
        +image
      &-1
        left: pxRes(234); top: pxRes(0); width: pxRes(49)
      &-2
        left: pxRes(132); top: pxRes(98); width: pxRes(88.5)
      &-3
        left: pxRes(205); top: pxRes(457); width: pxRes(80.5)
      &-4
        left: pxRes(0); top: pxRes(0); width: pxRes(117)
      &-5
        left: pxRes(0); top: pxRes(120); width: pxRes(117)
      &-6
        left: pxRes(135); top: pxRes(189); width: pxRes(80)
      &-7
        left: pxRes(0); top: pxRes(379); width: pxRes(284)
      &-8
        left: pxRes(131); top: pxRes(0); width: pxRes(86)
      &-9
        left: pxRes(112); top: pxRes(284); width: pxRes(104)
      &-10
        left: pxRes(0); top: pxRes(458); width: pxRes(78)
      &-11
        left: pxRes(104); top: pxRes(460); width: pxRes(80.5)
      &-12
        left: pxRes(0); top: pxRes(275); width: pxRes(95)
    .sticker-box-item-gray
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
  .tip
    color: #999999;
    background: #fff;
    font-size: 10px;
    text-align: center;
    position: relative;   
    margin: 0 pxRes(60); 
    line-height: 10px;
    padding-bottom: pxRes(60);
    &:before
      content: '';
      position: absolute;
      width: 50px;
      height: 1px;
      background: #eeeeee;
      left: 0;
      top: 5px;
    &:after
      content: '';
      position: absolute;
      width: 50px;
      height: 1px;
      background: #eeeeee;
      right: 0;
      top: 5px;  
</style>
